import  gql  from 'graphql-tag'

export const SHARE_BALANCE_FTP = gql`mutation shareBalanceByFtp($input: ShareBalanceBySFTPMutationInput!){
    shareBalanceByFtp(input: $input){
        errors{
            field
            messages
        }
    }
}`;